import { render } from "./ScholarshipRegistrationHeader.vue?vue&type=template&id=cac0a236&scoped=true"
const script = {}

import "../../components/Header/RegistrationHeader.scss?vue&type=style&index=0&id=cac0a236&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cac0a236"]])

export default __exports__